import { useState, useEffect } from "react";

// @mui material components
import { useSearchParams } from "react-router-dom";

// Material Kit 2 PRO React components
import MKBox from "../../components/MKBox";
import MKButton from "../../components/MKButton";

import apiIRA from "../../api/api.js";

// Image
import axios from "axios";
import constants from "../../common/constants";
import LivePasswordValidation from "../../layouts/AuthenticationCard/LivePasswordValidation";
import PageLayout from "../../layouts/dashboards";
import AuthenticationCardLayout from "../../layouts/AuthenticationCard/AuthenticationCardLayout";
import AuthenticationMKInput from "../../layouts/AuthenticationCard/AuthenticationMKInput";
import CustomInfoDialog from "../../components/Dialog";
import api from "../../api/api.js";

function Page() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  /* #region Authentication MKInput Variables  */
  const [isHitEnter, setIsHitEnter] = useState(false);
  const [events, setEvents] = useState(null);

  useEffect(() => {
    if (isHitEnter) {
      handleChangePassword();
      setIsHitEnter(false);
    }
  }, [isHitEnter]);
  const [inputs, setInputs] = useState({ new_hash: "", confirm_new_hash: "" });
  const [mkErrors, setMkErrors] = useState({
    new_hash: { state: false, message: "" },
    confirm_new_hash: { state: false, message: "" },
  });
  /* #endregion */

  /* #region CustomInfoDialog  */
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogParams, setInfoDialogParams] = useState({
    title: "",
    messageLine1: "",
    type: "info",
    navigateToUrl: "",
  });
  const handleOpenInfoDialog = (title, msg, type, navigateToUrl) => {
    setInfoDialogParams({
      ...infoDialogParams,
      title: title,
      messageLine1: msg,
      type: type,
      navigateToUrl: navigateToUrl,
    });
    setOpenInfoDialog(true);
  };

  /* #endregion */

  /* #region URL TOKENS -Retrieve Access Token From URL Parameters */
  const [urlParams, setUrlParams] = useState({
    subject: null,
    token: null,
  });
  useEffect(() => {
    var tmpUrlToken = searchParams.get("code");
    var tmpSubject = searchParams.get("id");
    if (
      tmpUrlToken == null ||
      tmpUrlToken == "" ||
      tmpSubject == null ||
      tmpSubject == ""
    ) {
      handleOpenInfoDialog(
        "Error - Invalid Token",
        "Invalid/Expired Token detected. Please access this page via link provided in your reset password email.",
        "error"
      );
    } else {
      setUrlParams({ ...urlParams, subject: tmpSubject, token: tmpUrlToken });
    }
  }, []);
  /* #endregion */

  const validateFields = () => {
    if (inputs.new_hash != inputs.confirm_new_hash) {
      setMkErrors({
        ...mkErrors,
        new_hash: { state: true, message: "" },
        confirm_new_hash: { state: true, message: "Passwords do not match" },
      });
      handleOpenInfoDialog(
        "Validation Error",
        "Passwords do not match. Please try again.",
        "error"
      );
      return false;
    } else if (inputs.new_hash == "" || inputs.confirm_new_hash == "") {
      setMkErrors({
        ...mkErrors,
        new_hash: { state: inputs.new_hash == "", message: "" },
        confirm_new_hash: { state: inputs.confirm_new_hash == "", message: "" },
      });
      handleOpenInfoDialog(
        "Error",
        "Please fill in all the Password fields",
        "error"
      );
      return false;
    }
    return true;
  };

  const handleChangePassword = async () => {
    setIsLoading(true);
    if (validateFields()) {
      var postBody = {
        id: urlParams.subject,
        email: "",
        code: urlParams.token,
        new_password: inputs.new_hash,
        confirm_password: inputs.confirm_new_hash,
        is_encrypted: false,
      };

      var headerObj = {};

      await axios
        .post(api.femsResetPassword, postBody)
        .then((res) => {
          if (res.data.errors != null) {
            var line = "An error occurred while changing password.\n\n";
            var ls = res.data.errors;
            ls.forEach((element) => {
              line = line + " *" + element.error_desc + "\n";
            });
            handleOpenInfoDialog("Error Occured", line, "error", "");
          } else {
            handleOpenInfoDialog(
              "Success",
              "You have changed your password successfully, please login.",
              "success",
              (constants.prefix_url + "login").toString()
            );
          }
        })
        .catch((err) => {
          setIsLoading(false);

          var line = "";
          var ls = err.response?.data?.errors ?? [];

          var errorCode = "";

          try {
            ls.forEach((element) => {
              line = line + " *" + element.error_desc + "\n";
              errorCode = ls.error_code;
            });
          } catch (ex) {
            line = line + " *" + ls.error_desc + "\n";
            errorCode = ls.error_code;
          }

          var appendAdditionalMessage =
            errorCode === constants.userAccountInvalidCode
              ? "\nPlease try generating a new link via forget password page or contact the administrator."
              : errorCode === constants.userAccountSamePasswordForPasswordChange
              ? "\nPlease try again."
              : "\nPlease contact the administrator or try again later. ";

          handleOpenInfoDialog(
            "Error Occurred",
            line + appendAdditionalMessage,
            "error",
            ""
          );
        });
    }
    setIsLoading(false);
  };

  return (
    <>
      <PageLayout isNoAuthPage={true}>
        <AuthenticationCardLayout
          title={"Reset Password"}
          subtitle={
            " Please enter your new password to reset password & access FEMS2.0 eServices"
          }
          loading={isLoading}
        >
          <AuthenticationMKInput
            inputType="password"
            inputName={"new_hash"}
            inputLabel={"New Password"}
            inputs={inputs}
            isMandatory={true}
            setInputs={setInputs}
            setEvents={setEvents}
            setIsEnter={setIsHitEnter}
            errorState={mkErrors.new_hash.state}
            errorMessage={mkErrors.new_hash.message}
          />
          <AuthenticationMKInput
            inputType="password"
            inputName={"confirm_new_hash"}
            inputLabel={"Confirm New Password"}
            inputs={inputs}
            isMandatory={true}
            setInputs={setInputs}
            setEvents={setEvents}
            setIsEnter={setIsHitEnter}
            errorState={mkErrors.confirm_new_hash.state}
            errorMessage={mkErrors.confirm_new_hash.message}
          />

          <MKBox display="flex" justifyContent="center">
            <MKBox mt={4}>
              <MKButton
                onClick={handleChangePassword}
                type="submit"
                color="info"
                size="large"
                fullWidth
                disabled={isLoading}
              >
                Submit
              </MKButton>
            </MKBox>
          </MKBox>

          <LivePasswordValidation
            hash={inputs.new_hash}
            confirm_new_hash={inputs.confirm_new_hash}
          />
        </AuthenticationCardLayout>
        <CustomInfoDialog
          open={openInfoDialog}
          title={infoDialogParams.title}
          messageLine1={infoDialogParams.messageLine1}
          type={infoDialogParams.type}
          navigateToUrl={infoDialogParams.navigateToUrl}
          setOpenDialog={setOpenInfoDialog}
        />
      </PageLayout>
    </>
  );
}

export default Page;
